import React from 'react';
import { cn } from '../../../../../lib/utils';
import { secondaryText } from '../../../../../styling/stylingHelper';

/**
 * A computation-owned caption under a chart ("Top 8 of 34 suppliers", "Weeks with no data are
 * omitted") — the computation's own words about what the reader is looking at.
 *
 * Deliberately NOT translated: the text is server-supplied, like the block's data. It sits one
 * step above `BlockSourceNote` in the hierarchy (xs/secondary vs 11px/tertiary) so the caption
 * and the provenance line read as two different things rather than one grey blur.
 *
 * Not clamped to a single visual line: a caption that wraps on a phone is better than one that
 * is silently cut off.
 */
export const BlockNote: React.FC<{ note?: string }> = ({ note }) => {
  if (!note) return null;
  return <p className={cn(secondaryText, 'text-xs mt-2')}>{note}</p>;
};

export default BlockNote;
